import React, { useState, useContext } from 'react'
import { Nav, Navbar, NavDropdown } from 'react-bootstrap'
import { Link, NavLink } from 'react-router-dom'
// import StyledNavDropdown from '../../styles/StyledNavDropdown'
import StyledNavBar from '../../styles/StyledNavBar'
import SearchBar from '../search/SearchBar'
import TopMarketBanner from '../../component/TopMarketBanner'
import MovieCartModal from '../popupModal/MovieCartModal';
import ContextApi from '../../ContextApi';

const NavigationBar = () => {
    const [showModal, setShowModal] = useState(false);
    const { auth, moviecartList } = useContext(ContextApi);

    const handleModalShow = () => {
        setShowModal(true);
    }

    const handleModalClose = () => setShowModal(false);

    return (
        <StyledNavBar>
            <TopMarketBanner />
            <Navbar collapseOnSelect expand="lg" variant='light' bg="white" fixed="top">
                <Navbar.Brand ><Link className='navbar-brand' to='/'><img className="logo" src="/images/HallmarkMedia_Logo_Plum_RGB.png" alt="Hallmark Media Intl Logo" /></Link></Navbar.Brand>
                <Navbar.Toggle aria-controls="responsive-navbar-nav" />
                <Navbar.Collapse id="responsive-navbar-nav">
                    <Nav className="mr-auto">
                        <Nav.Item><NavLink className='nav-link ' exact to={'/'}>Home</NavLink></Nav.Item>

                        <NavDropdown className="dropdown__menu" title="Releases" id="collasible-nav-dropdown" >
                            <NavDropdown.Item to="/releases/romance" as={NavLink}>Romantic Comedy | Romance | Drama</NavDropdown.Item>
                            <NavDropdown.Item to="/releases/mystery" as={NavLink}>Mystery</NavDropdown.Item>
                            <NavDropdown.Item to="/releases/christmas" as={NavLink}>Christmas</NavDropdown.Item>
                            <NavDropdown.Item to="/releases/series" as={NavLink}>Series</NavDropdown.Item>
                        </NavDropdown>

                        <Nav.Item><NavLink className='nav-link ' exact to={'/about'}>About</NavLink></Nav.Item>

                        {/* <Nav.Item><NavLink className='nav-link' exact to={'/news'}>News</NavLink></Nav.Item> */}

                        <Nav.Item><NavLink className='nav-link' exact to={'/contact'}>Contact</NavLink></Nav.Item>

                        {auth ?
                            <Nav.Item className='cart-icon'>
                                <i className="fas fa-shopping-cart" onClick={handleModalShow}></i>
                                <span className='cart-basket d-flex align-items-center justify-content-center'>{moviecartList.length === 0 ? null : moviecartList.length} </span>
                            </Nav.Item> :
                            null}

                        <Nav.Item>
                            <NavLink className='nav-link user' exact to={'/login'}>
                                <i className="fas fa-user"></i>
                            </NavLink>
                        </Nav.Item>

                        <SearchBar />


                    </Nav>
                </Navbar.Collapse>
            </Navbar>
            <MovieCartModal show={showModal} hide={handleModalClose} />
        </StyledNavBar>
    )
};


export default NavigationBar;